import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Customer';

  constructor(private titleService: Title) {}

  ngOnInit(): void {
    if (environment.ConfigParams.projectName) {
      this.titleService.setTitle(environment.ConfigParams.projectName);
    }
  }
}
